(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/closed-view/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/racing/closed-view/assets/javascripts/prescript.js');

'use strict';

svs = svs || {};
svs.racing = svs.racing || {};
svs.racing.closedView = svs.racing.closedView || {};

 })(window);